import { jsx as _jsx } from "react/jsx-runtime";
export function Icon({ name, size = 16, label, className }) {
    const beschriftet = label !== undefined;
    return (_jsx("svg", { width: size, height: size, className: className, role: beschriftet ? "img" : undefined, "aria-label": label, "aria-hidden": beschriftet ? undefined : true, focusable: "false", children: _jsx("use", { href: `#fa-${name}` }) }));
}
//# sourceMappingURL=Icon.js.map